import React from "react";
import { Modal, Input, Table, Popover, Button, DatePicker, } from "antd";
import {AddWasteProfile} from "./AddWasteProfile";
import {AddUpdateHotSheet} from "../../../tracks/hotsheet/popups/AddUpdateHotSheet";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const content = (
    <div className="action-column action-dropdown">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
);

export class AccountHotsheet extends React.Component {
  state={
    AddWasteProfile:false,
  }
  showAddWasteProfile=(visible)=>{
    this.setState({AddWasteProfile:visible})
  }
   setAddUpdateHotSheetModel(addUpdateHotSheetModel) {
    this.setState({addUpdateHotSheetModel});
  }

columns = [
  {
    title: 'Action',
    render: item =>
     <Popover placement="right" content={content} trigger="hover">
        <a className="action-dropdown" href="#"><i className="fa fa-ellipsis-h"/> </a>
      </Popover>
  },{
    title: <span>Hotsheet <br /> Number</span>,
  dataIndex: 'hotsheet_number',
  key: 'hotsheet_number',
}, {
  title: 'Generator',
  dataIndex: 'generator',
  key: 'generator',
}, {
  title: 'User',
  dataIndex: 'user',
  key: 'user',
},{
  title: 'Bill To',
  dataIndex: 'bill_to',
  key: 'bill_to',
},{
  title: 'Transporter',
  dataIndex: 'transporter',
  key: 'transporter',
},{
  title: 'Cycle',
  dataIndex: 'cycle',
  key: 'cycle',
},{
  title: <span>Service <br /> Date</span>,
  dataIndex: 'service_date',
  key: 'service_date',
},{
  title: <span>Next Service <br /> Date</span>,
  dataIndex: 'next_service_date',
  key: 'next_service_date',
},{
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
},
];

 data = [{
   key: '1',
   hotsheet_number: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   user: 'Dan',
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
   transporter: 'AB Oil Service Ltd',
   cycle: '2',
   service_date: '2018-11-29',
   next_service_date: '2018-12-05',
   status: <span className="completed"><i className="fa fa-circle"/></span>
},{
   key: '2',
   hotsheet_number: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   user: 'Dan',
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
   transporter: 'AB Oil Service Ltd',
   cycle: '2',
   service_date: '2018-11-29',
   next_service_date: '2018-12-05',
   status: <span className="completed"><i className="fa fa-circle"/></span>
},{
   key: '3',
   hotsheet_number: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   user: 'Dan',
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
   transporter: 'AB Oil Service Ltd',
   cycle: '2',
   service_date: '2018-11-29',
   next_service_date: '2018-12-05',
   status: <span className="completed"><i className="fa fa-circle"/></span>
},{
   key: '4',
   hotsheet_number: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   user: 'Dan',
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
   transporter: 'AB Oil Service Ltd',
   cycle: '2',
   service_date: '2018-11-29',
   next_service_date: '2018-12-05',
   status: <span className="completed"><i className="fa fa-circle"/></span>
},{
   key: '5',
   hotsheet_number: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   user: 'Dan',
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
   transporter: 'AB Oil Service Ltd',
   cycle: '2',
   service_date: '2018-11-29',
   next_service_date: '2018-12-05',
   status: <span className="completed"><i className="fa fa-circle"/></span>
},];

  render() {
    const { visible } = this.props;
    const rowSelection = {
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <Modal closable={false} style={{top:5}} visible={visible} onOk={() => this.props.onCancel()}
             onCancel={() => this.props.onCancel()} width='86%' className="view-data-modal view-hotsheet-mdl custom-header"
                title={<div className="row m-0">
              <div className="col-sm-6 col-12 view-modal-header text-left">
                <h3><span>Hotsheet</span></h3>
              </div>
              <div className="col-sm-6 col-12 view-modal-header text-right">
                <a href="#"> <i className="icon-printer" /> </a>
              </div>
            </div>}>
            <div className="row clearfix edit-header">
              <div className="col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker width={"100%"} />
                </div>
              </div>
              <div className="col-sm-2 col-2 padding-0">
                <button className="btn submit-btn h-auto xs-hide" type="button" onClick={() => this.setAddUpdateHotSheetModel(true)}>Create Hotsheet</button>
                <button className="btn submit-btn xs-show" type="button" onClick={() => this.setAddUpdateHotSheetModel(true)}><i
                  className="fa fa-plus" /></button>
              </div>
              <div className="col-sm-3 col-10">
                <Search placeholder="Input search text" style={{ width: "100%" }} />
              </div>
             <div className="col-sm-3 col-12 text-right">
               <Button className="advance-search-btn">Advance</Button>
               <Button className="advance-search-btn"><i className="fa fa-repeat" /> </Button>
              </div>
              <div className="col-12 edit-div text-right m-t-10">
                <span>5 Records</span>
                <button className="btn btn-edit" title="Trash">
                  <i className="fa fa-trash-o" />
                </button>
                <button type="primary" className="btn btn-edit">
                  <i className="fa fa-print" />
                </button>
                <button type="primary" className="btn btn-edit">
                  <i className="fa fa-eye" />
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="listing-table">
                  <Table rowSelection={rowSelection} className="responsive-table table table-hover waste-profile-tbl" columns={this.columns} dataSource={this.data} />
                </div>
              </div>
            </div>
            <AddWasteProfile visible={this.state.AddWasteProfile} onCancel={()=>this.showAddWasteProfile(false)} />
            <AddUpdateHotSheet visible={this.state.addUpdateHotSheetModel} setModelVisible={() => this.setAddUpdateHotSheetModel(false)}/>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/analytics/in_development/popups/AccountHotsheet.jsx